module.exports = __webpack_public_path__ + "img/share-bg-17.cb95eb98.jpg";